export class FileUploadError extends Error {
  public variableData?: Record<string, unknown>;

  constructor(message: string, variableData?: Record<string, unknown>) {
    super(message);
    this.name = 'FileUploadError';
    this.variableData = variableData;
  }
}
